<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">取样判定详情</h1>-->
    <!--</header>-->
    <div class="mui-content">
        <div style="padding-top: 10px;">
          <div class="title-name">
            <span class="">取样判定-编织</span>
          </div>
          <!--第一行-->
          <div class="form-group" style="margin-top: 10px;">
            <div class="input-label" style="flex: 4;">
              <label>取样外注卷号：</label>
            </div>
            <div class="form-input form-group-new" style="flex: 7;" >
              {{sampleinfo.tsdrollno}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>外注订单：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.ddh}}
            </div>          
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>物料：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.scxtwph+" "+sampleinfo.scxtwpmc}}
            </div>
          </div>         
          <div class="form-group">
            <div class="input-label">
              <label>取样机台：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.machineno}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>取样日期：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.sampletime}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>取样数量：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.amount}}米
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>取样人：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.sampleuser}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>判定日期：</label>
            </div>
            <div class="form-input form-group-new" >
              <input type="text" style="flex: 6;" :disabled="determineuserflg=='1'" v-model="info.determinetime" />
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>判定人：</label>
            </div>
            <div class="form-input form-group-new" >
              <input type="text" style="flex: 6;" :disabled="determineuserflg=='1'" v-model="info.determineuser" />
            </div>
          </div>
          <div class="form-group">
            <div class="input-label pt-7">
              <label>横断正面：</label>
            </div>
            <div class="form-input form-group-new" style=" display: flex;">
              <div style="flex: 1;">
                <select v-model="info.hdzm" :disabled="determineuserflg=='1'" style="width: 40px;padding: 0px;box-sizing: border-box;padding-left: 10px;">
                  <option v-for="item in zmLst" :value="item.scode">{{item.sname}}</option>
                </select>
              </div>
              <div class="input-label pt-7" style="flex: 1;">
                <label>整条：</label>
              </div>
              <div style="flex: 1;">
                <select v-model="info.st" :disabled="determineuserflg=='1'" style="width: 40px;padding: 0px;box-sizing: border-box;padding-left: 10px;">
                  <option v-for="item in stLst" :value="item.scode">{{item.sname}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label pt-7">
              <label>横断反面：</label>
            </div>
            <div class="form-input form-group-new" style=" display: flex;">
              <div class="form-group" style="flex: 1;">
                <!--<select v-model="info.st" :disabled="determineuserflg=='1'">-->
                  <!--<option v-for="item in stLst" :value="item.scode">{{item.sname}}</option>-->
                <!--</select>-->
                <select v-model="info.hdfm" :disabled="determineuserflg=='1'" style="width: 40px;padding: 0px;box-sizing: border-box;padding-left: 10px;">
                  <option v-for="item in fmLst" :value="item.scode">{{item.sname}}</option>
                </select>
              </div>
              <div class="input-label pt-7" style="flex: 1;">
                <label>油针：</label>
              </div>
              <div style="flex: 1;">
                <select v-model="info.yz" :disabled="determineuserflg=='1'"  style="width: 40px;padding: 0px;box-sizing: border-box;padding-left: 10px;">
                  <option v-for="item in yzLst" :value="item.scode">{{item.sname}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label pt-7">
              <label>风格：</label>
            </div>
            <div class="form-input form-group-new" style=" display: flex;">
              <!-- <div class="form-group" style="flex: 4;">
                <select v-model="info.fg" :disabled="determineuserflg=='1'">
                  <option v-for="item in fgLst" :value="item.scode">{{item.sname}}</option>
                </select>
              </div> -->
              <div class="form-group" style="flex: 4;">
                <input type="text" style="" :disabled="determineuserflg=='1'" v-model="info.fg" />
              </div>

            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>颜色：</label>
            </div>
            <div class="form-input form-group-new" >
              <input type="text" style="flex: 6;" :disabled="determineuserflg=='1'" v-model="info.ys" />
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>判定结果：</label>
            </div>
            <div class="form-input form-group-new" >
              <select  v-model="info.determineresult" style="border: 1px solid #CCCCCC;" :disabled="determineuserflg=='1'">
                <option v-for="item in resultLst" :value="item.scode">{{item.sname}}</option>
              </select>
            </div>
          </div>
           <div class="form-group">
            <label class="input-label">判定等级：</label>
            <div class="form-input" style="padding-top: 4px;">
              <div class="mui-input-row mui-radio mui-left">
                <label style="font-size: 14px;">A</label>
                <input type="radio" name="determinegrade" v-model="info.determinegrade" value="A" :disabled="determineuserflg=='1'">
              </div>
              <div class="mui-input-row mui-radio mui-left">
                <label style="font-size: 14px;">悬念反</label>
                <input type="radio" name="determinegrade" v-model="info.determinegrade" value="B" :disabled="determineuserflg=='1'">
              </div>
              <div class="mui-input-row mui-radio mui-left">
                <label style="font-size: 14px;">C</label>
                <input type="radio" name="determinegrade" v-model="info.determinegrade" value="C" :disabled="determineuserflg=='1'">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注：</label>
            </div>
            <div class="form-input form-group-new" >
              <textarea name="" rows="" cols="" v-model="info.remark" :disabled="determineuserflg=='1'"></textarea>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
      name: "samplingWeavingDetermine",
      data(){
        return{
          paraInfo:{ddh:"",wph:"",scxtwph:"" ,scxtwpmc:""},
          determineuserflg:"1",
          sampleinfo:{},// 取样信息
          info: {},// 判定信息
          resultLst: [],// 判定结果
          zmLst: [],// 悬念反组成 横段正面
          fmLst: [],// 悬念反组成 横段反面
          stLst: [],// 悬念反组成 竖条
          yzLst: [],// 悬念反组成 油针
          fgLst: [],// 悬念反组成 风格
        }
      },
      methods:{

      },
      activated() {
        var v=this;
        var para = getJsonPara(v.$route);
        var sampleno=para.sampleno;
        v.nyy.doPost("/Sample/getSampleDetail",{sampleno:sampleno,showinfoflg:"1",ddqf:"2"}, 
          function(result){
            if(result.status){
              v.sampleinfo=result.data.info;
              v.info=result.data.dinfo;
              var bLst=result.data.bLst;
              v.zmLst = JSON.parse(JSON.stringify(bLst));
              v.fmLst = JSON.parse(JSON.stringify(bLst));
              v.stLst = JSON.parse(JSON.stringify(bLst));
              v.yzLst = JSON.parse(JSON.stringify(bLst));
              v.fgLst = result.data.fgLst;
              v.resultLst = result.data.resultLst;
            }else {
                mui.toast(result.message);
                return;
            }
          }
        );
       
      },
      watch:{
         info: {
            handler: function (val) {
                this.info.determineuser = isText(val.determineuser);
            },
            deep: true
          }
      }
    }
</script>

<style scoped>
  @import "../../static/css/filterorder.css";
  @import "../../static/css/sampling.css";
  @import "../../static/css/update.css";
</style>



// WEBPACK FOOTER //
// src/components/samplingWeavingDetermine.vue